<template>
    <v-dialog v-model="dialog" max-width="450">
        <v-card class="v-card--dialog rounded-xl">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">현금영수증 발급 안내</h3>
                <v-btn fab color="transparent" class="v-card--dialog__close" @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-divider class="grey lighten-1 mt-10px"/>
            <v-card-text>
                - 현금성 결제수단으로 10원 이상 결제시 발급 가능합니다.
            </v-card-text>
            <v-card-text>
                - 현금영수증 발행 신청 가능 결제수단 : 캐시결제
            </v-card-text>
            <v-card-text>
                - 현금영수증 의무발행제도 시행으로, 현금성 결제금액 10만원 이상은 현금영수증이 신청과 무관하게 무조건 발행됩니다. 
            </v-card-text>
            <v-card-text>
                - 본인 외 타인 명의로 신청 가능합니다.
            </v-card-text>
            <v-card-text>
                - 현금영수증은 결제한 익일 국세청에 신고 되어 2~3일 내에 발행내역을 확인 할 수 있습니다.
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
        }
    }
}
</script>

<style scoped>
</style>